<template>
  <unicom-modal
    v-model="mostrar"
    :largura="1100"
    fechar
    @input="valor => fecharModal(valor)"
  >
    <template #header>
      <unicom-linha class="pb-4">
        <unicom-coluna sm="12" md="auto">
          <div class="titulo negrito cor-fonte fonte-primaria">Histórico</div>
        </unicom-coluna>
      </unicom-linha>
    </template>

    <template #body>
      <div class="body-tabela-erro">
        <unicom-tabela
          iconeMensagemVazia="search"
          mensagemVazia="Nenhum historico encontrado"
          mostrarNovoBlocoVazio
          alturaMinimaBody="196px"
          :icones="[]"
          :carregamento="loadingHistorico"
          :rows="listagemHistorico"
          :cabecalho="cabecalho"
          :exibirFooter="false"
        />
      </div>
    </template>
    <template #footer>
      <unicom-linha justificarItem="end">
        <unicom-coluna sm="12" md="auto" alinhamento="end">
          <unicom-botao
            class="fonte-secundaria texto"
            @click="fecharModal(false)"
            :altura="40"
            :largura="172"
            >FECHAR</unicom-botao
          >
        </unicom-coluna>
      </unicom-linha>
    </template>
  </unicom-modal>
</template>

<script>
import TabelaMixin from "@/shared/mixin/TabelaMixin";
import axios from "axios";

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  mixins: [TabelaMixin],
  data() {
    return {
      idValidacao: null,
      mostrar: this.value,
      listagemHistorico: [],
      listagemHistoricoVazio: [],
      loadingHistorico: {
        type: Boolean,
        default: false
      },
      cabecalho: [
        {
          texto: "Usuário",
          estiloColuna: {
            "min-width": "200px"
          }
        },
        {
          texto: "Data/Hora",
          estiloColuna: {
            "min-width": "155px"
          }
        },
        {
          texto: "Ação"
        },
        {
          texto: "Motivo",
          estiloColuna: {
            "min-width": "150px"
          }
        },
        {
          texto: "Campo"
        },
        {
          texto: "Valor Antigo",
          estiloColuna: {
            "min-width": "150px"
          }
        },
        {
          texto: "Valor Novo",
          estiloColuna: {
            "min-width": "150px"
          }
        }
      ]
    };
  },
  methods: {
    fecharModal(valor) {
      if (!valor) {
        this.listagemHistorico = this.listagemHistoricoVazio;
        this.$emit("input", false);
      }
    },
    montarTabela(rows, id) {
      this.listagemHistorico = [];
      this.idValidacao = id;
      this.loadingHistorico = true;
      this.loadingTabela = true;
      rows.forEach(e => {
        const {
          nomeUsuarioAlteracao,
          dataAlteracao,
          acao,
          motivoAlteracao,
          nomeCampoAlterado,
          valorAntigoCampo,
          valorNovoCampo
        } = e;
        this.listagemHistorico.push({
          nomeUsuarioAlteracao,
          dataAlteracao: dataAlteracao
            ? this.$helpers.formatadorHorario(dataAlteracao)
            : " - ",
          acao,
          motivoAlteracao,
          nomeCampoAlterado,
          valorAntigoCampo,
          valorNovoCampo
        });
      });
      this.loadingTabela = false;
      this.iniciado = true;
      this.loadingHistorico = false;
    },
    iniciarTabela() {
      this.loadingTabela = true;
      this.recuperarHistorico(this.idValidacao)
        .then(res => {
          this.montarTabela(res, this.idValidacao);
        })
        .finally(() => {});
    },
    recuperarHistorico(id) {
      return axios.get(
        this.CriarUrl({ resource: `adm/unimeds/contatos/historico/${id}` })
      );
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.divisor {
  border-left: 1px solid grey;
}
.espacamento {
  margin: 1rem 0;
  font-weight: bold;
}

.label-switch {
  margin: 10px 0;
}
</style>
